<template>
  <div class="koma">
    <header class="ems">
      <div class="header__container">
        <div class="title__container">
          <img :src="$store.state.user.job === 'Pemerintah' ? '/img/pemerintah-logo.png' : '/img/ems-logo.png'" alt="pemerintah logo" />
          <div class="flex__title">
            <h1>Indopride {{$store.state.user.job === 'Pemerintah' ? 'Pemerintah' : 'EMS'}}</h1>
            <p>Mobile Database Terminal</p>
          </div>
          
        </div>
        <div class="time__container">
          <p>{{getJakartaDate}}</p>
          <p>{{timestamp}}</p>
        </div>
        <div class="name__container">
          <p>Welcome,&nbsp;&nbsp; <span @click="clickHandler()" class="name__button">Logout</span></p>
        </div>
      </div>
    </header>
    <main class="half">
      <div class="ems__nav"></div>
      <div class="main">
        <div class="koma__table">
          <div class="overlay overlay--alt" v-if="loading">
            <div class="overlay__inner">
                <div class="overlay__content"><span class="spinner"></span></div>
            </div>
          </div>
          <div class="koma__table__container">
            <div class="koma__title">
              <h3>History Koma</h3>
            </div>
            <div class="form__control">
              <label for="firstname">Nama Depan:</label>
              <input name="firstname" type="text" v-model="firstname" disabled />
            </div>
            <div class="form__control">
              <label for="lastname">Nama Belakang:</label>
              <input name="lastname" type="text" v-model="lastname" disabled />
            </div>
            <div class="form__control">
              <label for="reason">Alasan:</label>
              <input name="reason" type="text" v-model="reason" />
            </div>
            <div class="button__control">
              <span class="name__button discard--button hide" :class="{show: reason !== ''}" @click="discardHandler()">Discard</span>
              <span class="name__button save--button" @click="saveKomaHandler(steamHex)">Save</span>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  
</template>
<script>
  import moment from 'moment'
  import SearchController from '../../Controller/SearchController.vue'
  import { message } from 'ant-design-vue';
  export default {
    extends: SearchController,
    data() {
      return {
        timestamp: '',
        firstname: '',
        lastname: '',
        reason: '',
        komaList: [],
        steamHex: '',
        loading: false,
      }
    },
    computed: {
      getJakartaDate() {
        const jakartaDate = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Jakarta"}));
        return jakartaDate.getDate() + '/' + (jakartaDate.getMonth() + 1) + '/' + jakartaDate.getFullYear(); 
      }
    },
    created() {
      console.log(moment('Wed Jan 18 2023 00:00:00 GMT-0800 (Pacific Standard Time)').format())
      const queries = new URLSearchParams(window.location.search);
      this.steamHex = queries.get('steamHex');
      this.getWarga(queries.get('steamHex'))
        .then(data => {
          if(data !== undefined) {
            this.firstname = data[0].firstname;
            this.lastname = data[0].lastname;
          }
        })
      this.getKoma(queries.get('steamHex'))
        .then(data => {
          console.log(moment(data.result[0].date).utc().format())
          console.log(data.result)
          if(data !== undefined) {
            this.komaList = data.result
          }
        })
      this.getNow();
      setInterval(() => {
        this.getNow()
      }, 1000);
    },
    methods: {
      getNow() {
        const date = new Date((new Date).toLocaleString("en-US", {
            timeZone: "Asia/Jakarta"
        }));
        let hours = '';
        let minutes = '';
        let seconds = '';
        hours = date.getHours().toString().length === 1 ? '0' + date.getHours() : date.getHours().toString();
        minutes = date.getMinutes().toString().length === 1 ? '0' + date.getMinutes() : date.getMinutes().toString();
        seconds = date.getSeconds().toString().length === 1 ? '0' + date.getSeconds() : date.getSeconds().toString();
        const fulldate = hours + ':' + minutes + ':' + seconds
        this.timestamp = fulldate
      },
      saveKomaHandler(steamHex) {
        if(steamHex !== '') {
          this.loading = true;
          this.saveKoma(steamHex, this.reason, 'Indopride')
            .then(data => {
              if(data.status !== undefined && data.status === 204) {
                const config = {
                  class: 'message-success',
                  content: `Koma berhasil dimasukan kedalam log`,
                  duration: 10
                }
                message.success(config)
                this.reason = '';
                this.loading = false;
              } else {
                const config = {
                  class: 'message-error',
                  content: data.msg,
                  duration: 10
                }
                message.error(config)
                this.loading = false;
              }
            })
        }
      }
    }
  }
</script>
<style scoped>
  .koma {
    width: 100vw;
    height: 100vh;
    background: #e5e3cb;
  }
  header {
    display: flex;
    height: 20vh;
    width: 95%;
    align-items: center;
  }
  .header__container {
    width: 97%;
    height: 70px;
    border-radius: 0 50px 50px 0;
    border: solid 5px #D6B200;
    border-left: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pemerintah .header__container {
    background: #003D19;
  }
  .ems .header__container {
    background: rgb(90, 1, 1);
  }
  img {
    width: 150px;
    margin-right: 20px;
    margin-left: 20px;

  }

  .title__container {
    margin-left: 20px;
    display: flex;
    align-items: center;
  }
  h1 {
    font-size: 1.5em;
  }
  p {
    margin-top: 10px;
  }
  .time__container {
    text-align: center;
    height: 85%;
    border-radius: 10px;
  }

  .pemerintah .time__container {
    background: #388b51;
  }

  .ems .time__container {
    background: rgb(141, 2, 2);
  }

  .time__container p {
    font-size: 1.2em;
    margin: 5px 20px;
  }

  .name__container {
    margin-right: 40px;
    opacity: 0;
  }

  .name__container p {
    font-size: 1.6em;
    margin-top: 0;
  }

  .name__button {
    background: red;
    padding: 10px 20px;
    font-size: 17px;
    display: inline-block;
    border-radius: 5px;
    margin-left: 10px;
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 2px;
  }

  .discard--button {
    color: black;
    background: lightgray;
    transform: scale(0);
    transition: all 0.2s;
    margin: 0;
  }

  .show {
    opacity: 1;
    transform: scale(1);
  }

  .save--button {
    color: white;
    background: darkblue
  }
  
  .main {
    border-top: solid 5px #fff;
    height: calc(100% - 5px);
    width: 100%;
    height: 100%;
  }
  .ems__nav {
    border-right: solid 5px #FFF;
    border-top: solid 5px #fff;
    background: rgb(90, 1, 1);
    height: 100%;
    width: 20%;
  }


  .half {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 80vh;
  }

  .koma__title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
  }

  .koma__table {
    height: 97%;
    background: rgb(90, 1, 1);
    margin: 10px;
    height: 97%;
    padding: 10px 20px;
    position: relative;
  }

  .koma__table__container h3 {
    font-size: 28px;
  }

  .koma__table__container label, .koma__table__container input {
    font-size: 18px;
  }

  .cell--header:last-child {
    width: 50%;
  }

  .koma__paragraph {
    margin: 10px 0;
    font-size: 18px;
  }

  .cell:last-child {
    width: 50%;
  }

  label {
    width: 200px;
  }

  input {
    color: black;
    border: solid 1px rgb(143, 143, 143);
    margin: 0;
    margin-left: 20px;
    padding: 20px 10px;
    border-radius: 5px;
    width: 100%;
    background: white;
  }

  input:disabled {
    background: #dddddd;
  }

  .overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 5;
  }

  .overlay__inner {
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      position: absolute;
  }

  .overlay__content {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
  }

  .spinner {
      width: 75px;
      height: 75px;
      display: inline-block;
      border-width: 2px;
      border-color: rgba(255, 255, 255, 0.05);
      border-top-color: #fff;
      animation: spin 1s infinite linear;
      border-radius: 100%;
      border-style: solid;
  }
  .overlay--alt {
    background: rgba(0,0,0,0.4)
  }
</style>